import {Button} from 'antd';
import styled, {css} from 'styled-components';
import UserDetails from '../UserDetails';
import {typographyStyles} from '../../utils/styles';

const StyledUserReview = styled.div`
  border: 1px solid ${props => props.theme.colors.neutral_3};
  border-radius: 4px;
  width: 100%;

  ${props => props.status === 'approved' && css`
    border-color: #8CD767;
    background-color: #EEF9E8;
  `}

  ${props => props.status === 'pending' && css`
    border-color: ${props => props.theme.colors.primary_6};
    background-color: ${props => props.theme.colors.primary_1};
  `}

  ${props => props.status === 'rejected' && css`
    border-color: ${props => props.theme.colors.functional_danger};
    background-color: #FEF3F2;
  `}

  ${props => props.status === 'default' && css`
    background-color: ${props => props.theme.colors.neutral_2};
  `}
`;

const StyledUserReviewActions = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  padding: 0 12px 12px 12px;
  width: 100%;

  .ant-btn {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    width: calc(50% - 2px);

    svg {
      height: 16px;
      width: 16px;
      path {
        transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }

    &.ant-btn-default {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.primary_5};
          }
        }
      }
    }

    &.ant-btn-primary {
      background-color: ${props => props.theme.colors.primary_6};
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
    }

    &.ant-btn-primary,
    &.ant-btn-default {
      &:disabled {
        background-color: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.25);
        svg {
          path {
            fill: rgba(0, 0, 0, 0.25);
          }
        }
      }
    }
  }
`;

const StyledUserReviewDetails = styled.div`
  padding: 12px;
`;

const StyledUserReviewDetailsEditButton = styled(Button)`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.primary_6};
  padding: 0;
`;

const StyledUserReviewStatusDetails = styled.div`
  ${typographyStyles.footnote.description};
  align-items: center;
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  justify-content: space-between;

  .ant-space-item {
    display: flex;
  }

  svg {
    height: 20px;
    width: 20px;
  }

  ${props => props.status === 'approved' && css`
    svg {
      path {
        fill: #169B62;
      }
    }
  `}

  ${props => props.status === 'rejected' && css`
    svg {
      rect {
        fill: ${props => props.theme.colors.functional_danger};
      }
    }
  `}
`;

const StyledUserReviewMessage = styled.p`
  ${typographyStyles.footnote.description};
  background-color: ${props => props.theme.colors.neutral_1};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: ${props => props.theme.colors.neutral_8};
  margin: 0;
  padding: 12px;
  border-top: 1px solid;

  ${props => props.status === 'approved' && css`
    border-color: #8CD767;
  `}

  ${props => props.status === 'pending' && css`
    border-color: ${props => props.theme.colors.primary_6};
  `}

  ${props => props.status === 'rejected' && css`
    border-color: ${props => props.theme.colors.functional_danger};
  `}
`;

const StyledUserReviewUserDetails = styled(UserDetails)`
  .ant-space-item {
    & > span {
      ${typographyStyles.body.medium};
    }
    display: flex;
  }
`;


export {
  StyledUserReview,
  StyledUserReviewActions,
  StyledUserReviewDetails,
  StyledUserReviewDetailsEditButton,
  StyledUserReviewMessage,
  StyledUserReviewStatusDetails,
  StyledUserReviewUserDetails
};
